export default __webpack_public_path__ + "static/media/git.50585275.svg";